enum ModalSizes {
  mini = "mini",
  tiny = "tiny",
  small = "small",
  large = "large",
  fullscreen = "fullscreen",
}

export default ModalSizes;
